import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-navbar-item gfu-navbar-dropdown"
}
const _hoisted_2 = {
  key: 0,
  class: "gfu-balloon__top-alert"
}
const _hoisted_3 = {
  class: "gfu-balloon__top-title",
  "data-qa": "user-box:FullName"
}
const _hoisted_4 = { "data-qa": "user-box:Email" }
const _hoisted_5 = {
  key: 1,
  class: "_tac _mt-1"
}
const _hoisted_6 = {
  key: 0,
  class: "_bb-2 _bc--soft _my-2"
}
const _hoisted_7 = { class: "gfu-link-underline__content" }
const _hoisted_8 = {
  key: 1,
  class: "_flex"
}
const _hoisted_9 = { class: "gfu-navbar-item _screen--none _screen--flex-m" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "gfu-navbar-btn" }
const _hoisted_12 = { class: "gfu-navbar-item _screen--none _screen--flex-m" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "gfu-navbar-btn" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_user_avatar = _resolveComponent("user-avatar")
  const _component_toggle_trigger = _resolveComponent("toggle-trigger")
  const _component_revert_impersonation_button = _resolveComponent("revert-impersonation-button")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_balloon = _resolveComponent("base-balloon")
  const _component_toggle_content = _resolveComponent("toggle-content")
  const _component_toggle_container = _resolveComponent("toggle-container")

  return ($options.isAuthenticated)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_toggle_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_toggle_trigger, {
              ref: "toggleTrigger",
              tag: "button",
              class: "gfu-navbar-btn gfu-navbar-dropdown-pointer",
              "active-class": "is-visible",
              tabindex: "0",
              "aria-label": _ctx.Resources.Layout.UserBoxTriggerLabel,
              "data-qa": "header-icon:Userbox"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_user_avatar)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["aria-label"]),
            _createVNode(_component_toggle_content, {
              class: "gfu-navbar-dropdown__content gfu-bt gfu-bt--b2",
              "active-class": "is-visible",
              tabindex: "0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_balloon, {
                  "is-pointer-visible": false,
                  position: "right",
                  "data-qa": "user-box"
                }, {
                  header: _withCtx(() => [
                    ($options.isImpersonated)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.Resources.Layout.UserBoxImpersonatingLabel), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.userContext.user.fullName), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.userContext.user.email), 1 /* TEXT */),
                    ($options.isImpersonated)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_revert_impersonation_button, { "data-qa": "user-box-button:Revert" })
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.groupedLinks, (value, key, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: key }, [
                          (index > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (link) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: link.navigationItemId
                            }, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(link.tag), {
                                rel: link.rel,
                                class: "_flex _py-1 _ai-c _gap-2 _fw-b _jc-fs gfu-link-underline",
                                href: link.to,
                                target: link.target,
                                onClick: link.action,
                                "data-qa": `user-box-button:${link.key}`
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_base_icon, {
                                    "icon-namespace": link.icon.namespace,
                                    name: link.icon.name,
                                    "is-fixed-width": true,
                                    size: "lg",
                                    class: "_tc--accent"
                                  }, null, 8 /* PROPS */, ["icon-namespace", "name"]),
                                  _createElementVNode("span", _hoisted_7, _toDisplayString(link.label), 1 /* TEXT */),
                                  (link.isTypeExternal)
                                    ? (_openBlock(), _createBlock(_component_base_icon, {
                                        key: 0,
                                        name: "external-link",
                                        "is-fixed-width": true,
                                        class: "_tc--accent _ml-a"
                                      }))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["rel", "href", "target", "onClick", "data-qa"]))
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            href: _ctx.loginUrl,
            "data-qa": "header-button:login"
          }, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.Resources.Layout.HeaderLoginLink), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", {
            href: _ctx.createAccountUrl,
            "data-qa": "header-button:signup"
          }, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.Resources.Layout.HeaderSignupLink), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_13)
        ])
      ]))
}